import React, { useState } from 'react'
import PropTypes from 'prop-types'

const VideoPlayer = ({ html, className }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <div 
      className={`video-player ${className}`}
      style={{ paddingBottom: '56.25%', position: 'relative', height: 0, overflow: 'hidden' }}
    >
      <div 
        dangerouslySetInnerHTML={{ __html: html }}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        onLoad={() => setIsLoaded(true)}
      />
      {!isLoaded && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          Загрузка видео...
        </div>
      )}
    </div>
  )
}

VideoPlayer.propTypes = {
  html: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default VideoPlayer